"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "buonvicino": {
    "dad6038c": [{
      "hkey": "3d115757",
      "slug": "buonvicino",
      "name": "Buonvicino",
      "primary": true,
      "skipSearch": false
    }],
    "conche": [{
      "hkey": "3d115757",
      "slug": "buonvicino",
      "name": "Buonvicino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "35af0350": [{
      "hkey": "53dd8fa4",
      "slug": "celle",
      "name": "Celle",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-celle": [{
      "hkey": "53dd8fa4",
      "slug": "celle",
      "name": "Celle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "40c1c6f5": [{
      "hkey": "5692afe7",
      "slug": "mezzane-massete",
      "name": "Mezzane-Massete",
      "primary": true,
      "skipSearch": false
    }],
    "massete": [{
      "hkey": "5692afe7",
      "slug": "mezzane-massete",
      "name": "Mezzane-Massete",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "buonvicino"
    }],
    "8c6e5889": [{
      "hkey": "5692afe7",
      "slug": "mezzane-massete",
      "name": "Mezzane-Massete",
      "primary": true,
      "skipSearch": false
    }],
    "mezzane": [{
      "hkey": "5692afe7",
      "slug": "mezzane-massete",
      "name": "Mezzane-Massete",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e0fc1ddd": [{
      "hkey": "475e6b16",
      "slug": "truglio-vignali",
      "name": "Truglio-Vignali",
      "primary": true,
      "skipSearch": false
    }],
    "truglio": [{
      "hkey": "475e6b16",
      "slug": "truglio-vignali",
      "name": "Truglio-Vignali",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2a69a7ee": [{
      "hkey": "475e6b16",
      "slug": "truglio-vignali",
      "name": "Truglio-Vignali",
      "primary": true,
      "skipSearch": false
    }],
    "vignali": [{
      "hkey": "475e6b16",
      "slug": "truglio-vignali",
      "name": "Truglio-Vignali",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "buonvicino"
    }],
    "973d3c5c": [{
      "hkey": "c55008d2",
      "slug": "visciglioso",
      "name": "Visciglioso",
      "primary": true,
      "skipSearch": false
    }],
    "visciglioso-visciglita": [{
      "hkey": "c55008d2",
      "slug": "visciglioso",
      "name": "Visciglioso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;